import chalk from 'chalk';

export const PREFIX_MAX_LENGTH = 40;

export const hlValue = chalk.cyanBright;
export const hlPkgId = chalk['whiteBright'];

export const ADDED_CHAR = chalk.green('+');
export const REMOVED_CHAR = chalk.red('-');
